/**
 * PATH: packages/job-hub/src/jobs/qa/qaPositionedMenu.tsx
 * FILE_ID: JOBHUB-QA-POSITIONED-MENU-001
 * PURPOSE: Wide-screen QA menu at the pointer, using the shared positioned menu.
 */
import {
  ContextMenu,
  ContextMenuHeader,
  ContextMenuItem,
  ContextMenuSeparator,
} from '@quotech/ui/contextMenu/positioned'
import type { ContextMenuItem as QaMenuItem } from '@quotech/ui'

export function QaPositionedMenu({ x, y, items, onClose }: {
  x: number
  y: number
  items: QaMenuItem[]
  onClose: () => void
}) {
  return (
    // Reused from: packages/quote-builder/src/components/ProductTreePane.tsx (ContextMenu x y onClose)
    <ContextMenu x={x} y={y} onClose={onClose}>
      {items.map((item) => {
        if (item.kind === 'separator') return <ContextMenuSeparator key={item.id} />
        if (item.kind === 'header') return <ContextMenuHeader key={item.id}>{item.label}</ContextMenuHeader>
        return (
          <ContextMenuItem
            key={item.id}
            icon={item.icon}
            disabled={item.disabled}
            variant={item.kind === 'destructive' ? 'danger' : 'default'}
            onClick={() => {
              if (item.disabled) return
              item.onSelect?.(undefined as never)
              onClose()
            }}
          >
            {item.label}
          </ContextMenuItem>
        )
      })}
    </ContextMenu>
  )
}
